<div class="w-full min-h-screen text-gray-900 flex flex-col">
  <!-- Background SVG overlay -->
  <div class="fixed inset-0 pointer-events-none select-none opacity-50 -z-10">
    <svg viewBox="0 0 1680 1373" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
      <path d="M894.499 1667H10.3878C-119.782 1667 -226 1560.98 -226 1431.05V559.999C-226 237.774 32.2563 -31.4402 348.829 -40.7952C510.239 -44.9529 662.277 14.295 777.867 126.554C878.879 225.301 940.319 353.151 953.856 491.397C1248.56 525.698 1480.78 771.005 1484.95 1068.28C1487.03 1228.36 1426.63 1378.04 1315.21 1492.37C1203.78 1604.63 1053.83 1667 894.499 1667ZM365.49 144.225C361.325 144.225 358.201 144.225 354.035 144.225C136.392 150.461 -39.5972 336.521 -39.5972 558.96V1430.01C-39.5972 1458.07 -16.6875 1480.94 11.4292 1480.94H894.499C1003.84 1480.94 1106.94 1438.32 1184 1360.37C1261.06 1282.41 1301.67 1179.5 1300.63 1070.36C1297.5 872.87 1147.55 709.678 953.856 677.456C942.401 851.042 899.706 1030.86 761.206 1170.15C585.216 1345.81 370.697 1314.63 248.858 1194.06C128.061 1073.48 96.8204 858.318 272.81 682.653C412.351 543.369 598.754 501.791 767.454 490.357C754.957 403.044 713.303 321.968 648.739 258.563C571.679 184.763 471.709 144.225 365.49 144.225ZM766.412 676.416C596.671 689.929 485.246 732.546 404.02 813.622C310.298 907.172 323.836 1005.92 380.069 1062.05C409.227 1091.15 446.716 1106.74 486.288 1106.74C534.19 1106.74 583.134 1082.84 628.953 1038.14C710.179 958.104 752.875 845.845 766.412 676.416Z" fill="url(#paint0_radial)"></path>
      <defs>
        <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientTransform="matrix(-1240.52 -4.83701 1584.21 -2298.78 741.285 378.583)" gradientUnits="userSpaceOnUse">
          <stop stop-color="#F1E3FF"></stop>
          <stop offset="1" stop-color="#F3E7FF"></stop>
        </radialGradient>
      </defs>
    </svg>
  </div>
  <!-- Header with two columns layout -->
  <div class="sticky top-0 bg-white z-10">
    <div class="grid grid-cols-2 items-center py-4 md:py-6">
      <!-- Left header cell: Back on mobile, Title on desktop -->
      <div class="flex items-center gap-2 px-3 md:px-8">
        <button class="p-2 rounded hover:bg-gray-100 md:hidden" aria-label="Back" (click)="handleBack()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg>
        </button>
        <div class="hidden md:block font-semibold">Settings</div>
      </div>
      <!-- Right header cell: Mobile title aligned right to balance two cols -->
      <div class="px-3 md:px-8 flex justify-start">
        <div class="md:hidden font-semibold">Settings</div>
      </div>
    </div>
    <div class="h-[1px] bg-gradient-to-r from-purple-200/40 via-purple-200/60 to-purple-200/20"></div>
  </div>

  <!-- Two-column main area -->
  <div class="px-3 pt-4 flex-1 md:px-8 md:pt-8 md:grid md:grid-cols-[260px_minmax(0,1fr)] md:gap-6">
    <!-- Left: sidebar buttons + footer. Always visible on md+, conditional on mobile -->
    <div class="space-y-4 flex flex-col h-full md:sticky md:top-8 md:self-start md:h-[calc(100vh-140px)] md:overflow-y-auto" [class.hidden]="(showProfile || showSubscription) && !isDesktop">
      <button class="w-full text-left" (click)="openProfile()">
        <div class="flex items-center gap-3 bg-white rounded-2xl shadow-sm border border-gray-200 p-4">
          <div class="w-10 h-10 rounded-xl bg-purple-100 text-purple-500 flex items-center justify-center text-lg font-bold">🔒</div>
          <div class="flex-1">
            <div class="text-sm font-extrabold tracking-wide">ACCOUNT</div>
            <div class="text-sm text-gray-500">Your data and settings</div>
          </div>
          <div>
            <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
          </div>
        </div>
      </button>

      <button class="w-full text-left" (click)="openSubscription()">
        <div class="flex items-center gap-3 bg-white rounded-2xl shadow-sm border border-gray-200 p-4">
          <div class="w-10 h-10 rounded-xl bg-purple-100 text-purple-500 flex items-center justify-center text-lg font-bold">💲</div>
          <div class="flex-1">
            <div class="text-sm font-extrabold tracking-wide">SUBSCRIPTION</div>
            <div class="text-sm text-gray-500">{{userService.isSubscribed? 'Subscription is active': 'No active subscription'}}</div>
          </div>
          <div>
            <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
          </div>
        </div>
      </button>

      <!-- Footer lives within left column so it stays with sidebar -->
      <div class="mt-auto px-0 py-6 border-t border-gray-200 bg-white md:bg-transparent md:border-0 md:sticky md:bottom-0 md:block" [class.hidden]="(showProfile || showSubscription) && !isDesktop">
        <div class="text-3xl font-extrabold tracking-tight">IVY</div>
        <ul class="mt-6 space-y-4 text-gray-800">
          <li><a class="hover:underline" href="https://legal.stringhealth.ai/privacy-policy.html" target="_blank">Privacy Policy</a></li>
          <li><a class="hover:underline" href="https://legal.stringhealth.ai/terms-of-use.html" target="_blank">Terms and Conditions</a></li>
        </ul>
        <div class="mt-6">
          <button class="text-purple-600 underline" (click)="logout()">Logout</button>
        </div>
      </div>
    </div>

    <!-- Right: main area. Always visible on md+, conditional on mobile -->
    <div class="md:col-start-2 md:relative" [class.hidden]="!(showProfile || showSubscription)">
      <div *ngIf="showProfile" class="animate-slide-in-x">
        <app-profile></app-profile>
      </div>
      <div *ngIf="showSubscription" class="animate-slide-in-x">
        <app-subscription-details></app-subscription-details>
      </div>
    </div>
  </div>
</div>

